import { render, staticRenderFns } from "./AtsLogo.vue?vue&type=template&id=1497ed24&scoped=true"
import script from "./AtsLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AtsLogo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AtsLogo.vue?vue&type=style&index=0&id=1497ed24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497ed24",
  null
  
)

export default component.exports